// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './hooks/AuthContext';
import { AppProvider } from './contexts/AppContext';
import { GoogleCalendarProvider } from './contexts/GoogleCalendarContext';
import { TemplateProvider } from './modules/messageGenerator/contexts/TemplateContext';

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <AuthProvider>
    <AppProvider>
      <GoogleCalendarProvider>
        <TemplateProvider>
          <App />
        </TemplateProvider>
      </GoogleCalendarProvider>
    </AppProvider>
  </AuthProvider>
);

// Register service worker for offline support
serviceWorkerRegistration.register();
